import React from 'react';
import { motion } from 'framer-motion';
import { Target, Landmark, Network } from 'lucide-react';
export function PlatformHumanOpportunity() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 bg-teal-pale border-y border-line/50" data-id="element-391">
      <div className="max-w-7xl mx-auto" data-id="element-392">
        <div className="max-w-3xl mb-16" data-id="element-393">
          <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-394">
            Human Opportunity and Development
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark mb-6" data-id="element-395">
            Every weakness should be paired with a pathway
          </h2>
          <div className="space-y-4 text-lg text-ink-muted leading-relaxed" data-id="element-396">
            <p data-id="element-397">
              A core pillar of the platform is its Human Opportunity and
              Development framework. This component exists to ensure that the
              system is developmental rather than merely diagnostic. It is
              designed to increase self-awareness, guide individuals toward
              practical pathways for success, and strengthen communities through
              better alignment of talent, support, and resources.
            </p>
            <p data-id="element-398">
              Instead of reducing people to a fixed label, the platform is
              designed to identify practical growth opportunities. It does not
              stop at "not ready." It moves toward a more useful question: what
              would readiness require, and how can it be built?
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-399">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white p-8 rounded-lg border border-line shadow-sm" data-id="element-400">
            <div className="flex items-center gap-4 mb-4" data-id="element-401">
              <div className="text-teal" data-id="element-402">
                <Target size={24} strokeWidth={1.5} data-id="element-403" />
              </div>
              <h3 className="text-lg font-heading font-bold text-ink-dark" data-id="element-404">
                Self-Directed Improvement
              </h3>
            </div>
            <p className="text-ink-muted" data-id="element-405">
              Learning tools, structured action steps, planning systems, and
              personal development pathways.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="bg-white p-8 rounded-lg border border-line shadow-sm" data-id="element-406">
            <div className="flex items-center gap-4 mb-4" data-id="element-407">
              <div className="text-navy-light" data-id="element-408">
                <Landmark size={24} strokeWidth={1.5} data-id="element-409" />
              </div>
              <h3 className="text-lg font-heading font-bold text-ink-dark" data-id="element-410">
                Institutional Support
              </h3>
            </div>
            <p className="text-ink-muted" data-id="element-411">
              Schools, employers, mentors, and organizational development
              systems that can reinforce growth.
            </p>
          </motion.div>

          {/* Card 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white p-8 rounded-lg border border-line shadow-sm" data-id="element-412">
            <div className="flex items-center gap-4 mb-4" data-id="element-413">
              <div className="text-navy" data-id="element-414">
                <Network size={24} strokeWidth={1.5} data-id="element-415" />
              </div>
              <h3 className="text-lg font-heading font-bold text-ink-dark" data-id="element-416">
                Community & Public Support
              </h3>
            </div>
            <p className="text-ink-muted" data-id="element-417">
              Programs, networks, public resources, and local opportunity
              systems that help translate potential into progress.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}